import { createGlobalStyle } from 'styled-components';
import { theme } from '../styles/constants';

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  html {
    font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25%
  }

  html,
  body {
    box-sizing: border-box;
    overflow: hidden;
    touch-action: none;
    overscroll-behavior: none;
    // Locked to the keyboard-stable viewport height (see App.js). The keyboard
    // overlays this fixed box instead of resizing / pushing / translating it.
    height: var(--app-height, 100%);
    margin: 0;
    padding: 0;
  }

  body {
    // Fixed positioning stops iOS WKWebView from scrolling the whole webview
    // up to reveal the focused input, which would translate the content.
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--app-height, 100%);
    font-weight: 400;
    font-size: 1.7rem;
    font-family: Inter, sans-serif;
    line-height: normal;
    margin: 0;
    color: ${theme.colors.textColor};
    background: linear-gradient(180deg, #1c1d1f 0%, #0f0f10 100%);
  }

  input,
  select,
  textarea,
  button {
    font-family: inherit;
  }

  a,
  p,
  svg,
  button,
  div {
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
  }

  #root {
    height: var(--app-height, 100%);
    overflow: hidden;
  }

  .success-toast-message {
    background-color: #26134e;
    color: #fff;
    border-radius: 1.2rem;
  }

  .success-toast-message-progress {
    background-color: #3e9be4;
  }
`;

export default GlobalStyles;
